import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import FormValidationUtils from "../../utilities/FormValidationUtils";

import { displayField, getRootComponent } from "../../utilities/ElementUtils";
interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {
 
}
export class PhoneComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);
    let field = this.props.field;
    field.IsDirty = false;
    FormValidationUtils.runInitJavascript(field);
    
  }

  onBlur = (e) => {
    let field = this.props.field;
    FormValidationUtils.validatePhoneNumber(field);
    if(field.Valid){
     FormValidationUtils.runJavascript(field);
    } 
    this.props.callbackElement(getRootComponent(field));
  }
  render() {
    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
    const programContainer = getRootComponent(field);
    field.Visible = displayField(field);
    if(!field.Visible) return null;
    let editable = this.props.editable;
    let labelControlArray = this.props.labelControlArray;
    let requiredField = this.props.requiredField;
    let controlArray = [];
    let title = this.props.title;
    const validClass = "ontario-input ontario-input--20-char-width";
        const invalidClass = "ontario-input ontario-input--20-char-width ontario-input__error";
    let hintHtml = this.props.isEng ? field.Hint : field.HintFR;
    if (editable) {
      controlArray.push(
        <div key={'div_' + field.Datatype +'_' + field.Id} id= {'div_' + field.Datatype +'_' + field.Id}  >

          <div key={'fdLbl_div_' + field.Id} >
            {labelControlArray}
          </div>
          <div>

          </div>
          <div key={'fdIpt_div_' + field.Id} >
            <div>
            {!getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
              <input  className={field.Valid || !field.Touched ? validClass : invalidClass} id={field.LoadBindName} key={'fdIpt_' + field.Id} 
                style={{...(getRootComponent(field).ErrorBottom && { marginBottom: '4px' }) }}
                required={requiredField} value={field.Value??''} readOnly={field.ReadOnly}
                onBlur={this.onBlur} 
                aria-required={field.Optional !== 'Y'}
                aria-describedby={
                  [!field.Valid && `${field.LoadBindName}-${field.Id}-error`, hintHtml && `hint-text-${field.LoadBindName}`]
                    .filter(Boolean)
                    .join(' ') || undefined
                }
                aria-invalid={!field.Valid && field.Touched ? true : undefined}
                onChange={(e) => {
                  field.Value =  e.target.value;
                  FormValidationUtils.markFieldDirty(field);
                  FormValidationUtils.runKeyStrokeJavascript(field);
                  this.props.callbackElement(getRootComponent(field));
                }} />
              {getRootComponent(field).ErrorBottom&&(<LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + field.LoadBindName}
              id={`${field.LoadBindName}-${field.Id}`}
            />)}
            </div>
          </div>
        </div>);
    } else {
      controlArray.push(  <div 
        key={'div_' + field.Datatype + '_' + field.Id} 
        className={programContainer.isHorizontalLayout ? 'pdf-row-column' : 'pdf-two-column'}
      > 
          <div key={'div2_' + field.Datatype +'_' + field.Id}>{title}</div>
          <div key={'div3_' + field.Datatype +'_' + field.Id} className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && requiredField })} >{this.props.field.Value}</div>
        </div>
      );
    }

    return controlArray;

  }

}
